// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-players_App__Dps4- {
    display: flex;
    flex-direction: row;
    align-items: start;
    gap: 10px;
    flex-grow: 1;
    min-height: 0;

    overflow-x: auto;
}

.tournament-players_TourPlayers__qPY1m {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: max-content;
    height: 100%;
    width: 290px;
    padding: 20px;

    >div:nth-child(1) {
        text-align: center;
        font-family: "Roboto","Helvetica","Arial",sans-serif;
        font-size: 20px;
        text-transform: uppercase;
        font-weight: 800;
        color: rgb(0, 0, 0);
    }

    >div:nth-child(3) {
        flex-grow: 1;
        min-height: 0;
        overflow: auto;
    } 
}

.tournament-players_AddPlayers__B7WhV {
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    border: 1px solid blue;
    padding: 7px 10px;
    padding-left: 30px;
    border-radius: 25px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: rgb(20, 28, 255);
}

.tournament-players_Players__CbDhN {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: max-content;
    height: 100%;
    width: 290px;
    padding: 20px;

    >div:nth-child(1) {
        text-align: center;
        font-family: "Roboto","Helvetica","Arial",sans-serif;
        font-size: 20px;
        text-transform: uppercase;
        font-weight: 800;
        color: rgb(0, 0, 0);
    }

    >div:nth-child(2) {
        border-bottom: 1px solid black;
        margin: 9px 0px;
        width: 250px;
    }

    >div:nth-child(3) {
        flex-grow: 1;
        min-height: 0;
        overflow: auto;
    } 
}

@media (min-width: 768px) {
    .tournament-players_AddPlayers__B7WhV {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/TournamentsPageN/ui/tournament-players.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;;IAEb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;;IAEb;QACI,kBAAkB;QAClB,oDAAoD;QACpD,eAAe;QACf,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,cAAc;IAClB;AACJ;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;;IAEnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;;IAEb;QACI,kBAAkB;QAClB,oDAAoD;QACpD,eAAe;QACf,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,8BAA8B;QAC9B,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".App {\n    display: flex;\n    flex-direction: row;\n    align-items: start;\n    gap: 10px;\n    flex-grow: 1;\n    min-height: 0;\n\n    overflow-x: auto;\n}\n\n.TourPlayers {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    width: max-content;\n    height: 100%;\n    width: 290px;\n    padding: 20px;\n\n    >div:nth-child(1) {\n        text-align: center;\n        font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n        font-size: 20px;\n        text-transform: uppercase;\n        font-weight: 800;\n        color: rgb(0, 0, 0);\n    }\n\n    >div:nth-child(3) {\n        flex-grow: 1;\n        min-height: 0;\n        overflow: auto;\n    } \n}\n\n.AddPlayers {\n    user-select: none;\n    cursor: pointer;\n    border: 1px solid blue;\n    padding: 7px 10px;\n    padding-left: 30px;\n    border-radius: 25px;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    color: rgb(20, 28, 255);\n}\n\n.Players {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    width: max-content;\n    height: 100%;\n    width: 290px;\n    padding: 20px;\n\n    >div:nth-child(1) {\n        text-align: center;\n        font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n        font-size: 20px;\n        text-transform: uppercase;\n        font-weight: 800;\n        color: rgb(0, 0, 0);\n    }\n\n    >div:nth-child(2) {\n        border-bottom: 1px solid black;\n        margin: 9px 0px;\n        width: 250px;\n    }\n\n    >div:nth-child(3) {\n        flex-grow: 1;\n        min-height: 0;\n        overflow: auto;\n    } \n}\n\n@media (min-width: 768px) {\n    .AddPlayers {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `tournament-players_App__Dps4-`,
	"TourPlayers": `tournament-players_TourPlayers__qPY1m`,
	"AddPlayers": `tournament-players_AddPlayers__B7WhV`,
	"Players": `tournament-players_Players__CbDhN`
};
export default ___CSS_LOADER_EXPORT___;
